import auth from '@/auth/index'

let routes = [
  {
    path: '',
    component: resolve => require(['@/views/layout/Layout'], resolve),
    meta: {
      title: '身份认证',
      breadLevel: 0,
      icon: 'icon-identity',
      auth: auth.certificate
    },
    children: [
      {
        path: '/certificate',
        name: 'certificate',
        component: resolve => require(['@/views/identitySystem/certificate/index'], resolve),
        meta: {
          title: '证书认证',
          breadLevel: 0,
          auth: auth.certificate.certAuth
        }
      },
      {
        path: '/ibcIdentificationAuthentication',
        name: 'ibcIdentificationAuthentication',
        component: resolve =>
          require(['@/views/identitySystem/ibcIdentificationAuthentication/index'], resolve),
        meta: {
          title: 'IBC标识认证',
          breadLevel: 0,
          auth: auth.certificate.IBCAuth
        }
      },
      {
        path: '/publicKeyIdentificationAuthentication',
        name: 'publicKeyIdentificationAuthentication',
        component: resolve =>
          require(['@/views/identitySystem/publicKeyIdentificationAuthentication/index'], resolve),
        meta: {
          title: '公钥认证',
          breadLevel: 0,
          auth: auth.certificate.publicKeyAuth
        }
      }
    ]
  }
]

export default routes
